export const env = {
  BASE_URL: process.env.VITE_BASE_URL,
  GEO_URL: process.env.VITE_GEO_URL,
  MAPBOX_TOKEN: process.env.VITE_MAPBOX_TOKEN,
} as const;
